import React from "react";
import { useState } from "react";

export default function Services(props) {
  const [isHovered, setIsHovered] = useState(false);
  const gradientStyle = {
    background: isHovered
      ? "radial-gradient(circle, rgb(10, 10, 10,0.3), #000000)"
      : "#000000",
    transition: "background 0.3s ease-in-out",
  };

  return (
    <div
      style={gradientStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="md:px-8 md:py-6 px-4 py-5 flex flex-col gap-2 md:w-[23rem] md:h-[18rem] w-[14rem] h-[18rem] md:rounded-2xl rounded-xl border-[0.03rem]   border-[#444D61] "
    >
      <div className="flex md:gap-3 gap-2 md:py-1 pt-1 items-center justify-center">
        {props.logo && (
          <img
            className="md:w-[3.75rem] md:h-[3.75rem] w-[2.5rem] h-[2.5rem]"
            src={require(`../../src/Images/Services/${props.logo}.png`)}
            alt={`${props.heading} Logo`}
          />
        )}
        <div className="flex flex-wrap md:w-[14.1rem] w-[9rem] text-[#1B99D4] font-RobotoBold md:text-xl text-sm ">
          {props.heading}
        </div>
      </div>
      {/* <div className="  border border-[#D9FBFF]/50 "></div> */}
      <p className="text-white font-RobotoRegular text-xs md:text-sm  flex flex-wrap text-left md:mt-2 px-1 py-1 ">
        {props.data}
      </p>
    </div>
  );
}
